/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-04-23 16:57:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-13 16:21:39
 * @FilePath: /src/components/Upload/components/ImagePreview/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { env } from '@/utils/env';
import { Box, CircularProgress } from '@mui/material';
import { CloseOutlined, ErrorTipOutlined } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import Image from '@/components/Image';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { FileType, ImageItem } from '../../index';

export interface ImagePreviewProps {
  /* 文件类型 */
  fileType: FileType;
  /* 已上传文件链接 */
  fileUrls: ImageItem[];
  /* 删除文件 */
  onDelete: (id: string) => void;
  mode?: 'normal' | 'upload';
}

export default function ImagePreviewComponent({
  fileType,
  fileUrls,
  onDelete,
  mode = 'normal',
}: ImagePreviewProps) {
  const t = useTranslations('components.upload');
  // 如果没有文件且没有正在上传的文件，不显示任何内容
  if (fileUrls.length === 0) return null;

  return (
    <Box sx={{ display: mode === 'upload' ? 'contents' : 'flex', flexWrap: 'wrap', gap: 1 }}>
      {fileUrls.map(({ id, url, status, s3Url }, index) => (
        <Box
          key={`img-${id}-${index}`}
          sx={{
            position: 'relative',
            width: '80px',
            height: '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          {/* 加载蒙版 */}
          {status === 'uploading' && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '12px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                zIndex: 1,
              }}
            >
              <CircularProgress size={24} sx={{ color: 'white' }} />
            </Box>
          )}

          {/* 上传失败蒙版 */}
          {status === 'error' && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '8px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <ErrorTipOutlined style={{ fontSize: '22px', marginBottom: '6px' }} />
                <Box sx={{ fontSize: '12px' }}>{t('failed')}</Box>
              </Box>
              {/* 重试功能暂时注释
              {onRetry && (
                <Tooltip title="重试上传" arrow>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onRetry(id);
                    }}
                    sx={{ color: 'white' }}
                  >
                    <span>reload</span>
                  </IconButton>
                </Tooltip>
              )}
              */}
            </Box>
          )}

          {fileType === 'image' && (s3Url || url) && (
            <PhotoProvider
              key={`provider-${id}`}
              maskClassName="!bg-black/50"
              bannerVisible={false}
            >
              {s3Url ? (
                <PhotoView src={`${env.NEXT_PUBLIC_S3_URL}${s3Url}`}>
                  <Image
                    src={url}
                    alt="image preview"
                    width={80}
                    height={80}
                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                    className="rounded-[12px]"
                  />
                </PhotoView>
              ) : (
                <Image
                  src={url}
                  alt="image preview"
                  width={80}
                  height={80}
                  style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                  className="rounded-[12px]"
                />
              )}
            </PhotoProvider>
          )}

          <Box
            sx={{
              position: 'absolute',
              zIndex: 2,
              top: '-4px',
              right: '-4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              borderRadius: '50%',
            }}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(id);
            }}
          >
            <CloseOutlined className="text-white" />
          </Box>
        </Box>
      ))}
    </Box>
  );
}
